import {
  Box,
  Button,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { getInitials, getName } from 'utils/account.utils';
import { borderedCardHover, KeyboardPaddingBottom } from 'utils/styles.utils';

import { Routes } from 'constants/routes.constants';
import { useModalControl } from 'hooks/useModalControl';
import { useAccount } from 'queries/accounts/useAccount';
import { useAccountAddresses } from 'queries/accounts/useAccountAddresses';

import AddAddressForm from 'components/@account/AddAddressForm';
import BorderStack from 'components/@common/BorderStack';
import Dialog from 'components/@common/Dialog';
import LinkUnstyled from 'components/@common/LinkUnstyled';
import Icon from 'components/@icons/Icon';

const NameCard = () => {
  const { address } = useAccountAddresses();
  const { account } = useAccount();
  const { open, onClose, onOpen } = useModalControl();
  const showCompleteProfile = !address;

  return (
    <Box>
      <BorderStack
        component={LinkUnstyled}
        href={Routes.AccountDetails}
        sx={(theme) => ({
          ...borderedCardHover(theme),
          flexDirection: 'row',
          gap: 1,
          justifyContent: 'space-between',
          alignItems: 'center',
          ...(showCompleteProfile && {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          }),
        })}
      >
        <Box
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 56,
            minWidth: 56,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              textTransform: 'uppercase',
              mb: -0.5,
            }}
          >
            {getInitials(account)}
          </Typography>
        </Box>
        <Typography
          variant="h7"
          sx={{
            flexGrow: 1,
          }}
        >
          {getName(account)}
        </Typography>
        <Icon name="ChevronRight" rotateInArabic fontSize={20} />
      </BorderStack>
      {showCompleteProfile && (
        <>
          <BorderStack
            sx={{
              borderTop: 'none',
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              alignItems: 'flex-start',
              bgcolor: 'grey.900',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                width: '100%',
                mb: 2,
              }}
            >
              <Box
                sx={{
                  height: '4px',
                  borderTopLeftRadius: '2px',
                  borderBottomLeftRadius: '2px',
                  bgcolor: 'global01.400',
                  width: '70%',
                }}
              />
              <Box
                sx={{
                  height: '4px',
                  borderTopRightRadius: '1px',
                  borderBottomRightRadius: '1px',
                  bgcolor: 'grey.600',
                  width: '30%',
                }}
              />
            </Box>
            <Typography
              variant="small"
              sx={{
                fontWeight: 'bold',
                mb: 1,
              }}
            >
              <FormattedMessage id="account.complete.profile.title" />
            </Typography>
            <Button variant="text" color="primary" onClick={onOpen}>
              <FormattedMessage id="account.complete.profile.button" />
            </Button>
          </BorderStack>
          <Dialog open={open} onClose={onClose}>
            <DialogTitle>
              <FormattedMessage id="account.address.add.button" />
            </DialogTitle>
            <DialogContent sx={KeyboardPaddingBottom}>
              <AddAddressForm onClose={onClose} />
            </DialogContent>
          </Dialog>
        </>
      )}
    </Box>
  );
};

export default NameCard;
